import data from "./country_list.json";

export const getCountryNameByCountryCode = (country_code) =>
  data.find(({ code }) => code === country_code)?.name_pl ||
  "-";
